import { ViewContracts } from 'customer-management/customer-details/view-contracts/view-contracts';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { PERMISSIONS } from 'shared/constants';
import { useUserPermissions } from 'shared/hooks/use-user-permissions';
import { useGetContract, useGetDraftContract } from 'shared/queries';
import { useAuthState } from 'shared/stores';
import { AppPermission } from 'shared/types';
import { useTitle } from 'shared/hooks';
import { ContractRouteParams } from 'shared/types/routing';
import { checkPermissions } from 'shared/utility';

export function ViewContractsResolver() {
  const { contractId } = useParams<ContractRouteParams>();
  const { contract } = useGetContract(contractId);
  const { draftContract } = useGetDraftContract(contractId);
  const authState = useAuthState();
  const user = authState.user.value;
  const userPermissions = useUserPermissions();

  useTitle('View Contracts - American Bath');

  const hasPermissions = useCallback(
    (...appPermissions: AppPermission[]) => checkPermissions(userPermissions)(...appPermissions),
    [userPermissions]
  );
  const hasControllerPermission = userPermissions.includes('abg-retail.controller');

  const canReview = hasPermissions(PERMISSIONS['contract.review']);
  const hasEditPermission = hasPermissions(PERMISSIONS['contract.edit']) && !hasControllerPermission;
  const isDraft = draftContract !== undefined;

  if (!contract || !user) {
    return null;
  }

  return (
    <>
      <ViewContracts
        contract={isDraft ? draftContract : contract}
        canReview={canReview}
        hasEditPermission={hasEditPermission}
        isDraft={isDraft}
        user={user}
      />
    </>
  );
}
